module.exports = __webpack_public_path__ + "img/tpc-web-1.94932b9e.webp";